export const PRODUCTS = [
  {
    id: 1,
    title: 'Планер "Чемпіон"',
    desc: 'Ідеально для активних хлопчиків, які обожнюють спорт та перемоги.',
    fullDesc:
      'Цей планер створений спеціально для маленьких спортсменів. Він допомагає відстежувати не лише щоденні рутини, але й спортивні досягнення. Яскравий дизайн з кубками та медалями мотивує дитину ставати кращою щодня та досягати нових висот.',
    img: 'https://cdn.magicpatterns.com/uploads/p92czmuobStJMG3o856bYp/IMG_5251.jpg',
    price: '1000',
  },
  {
    id: 2,
    title: 'Планер "Дослідник"',
    desc: 'Для юних шукачів пригод, які цікавляться динозаврами та природою.',
    fullDesc:
      'Ідеальний вибір для допитливих малюків. Дизайн з динозаврами перетворює виконання щоденних завдань на захопливу експедицію. Допомагає розвивати самостійність через гру та інтерес до навколишнього світу.',
    img: 'https://cdn.magicpatterns.com/uploads/nihtqabZLJ8p5YyHvVbA2W/IMG_5250.jpg',
    price: '1000',
  },
  {
    id: 3,
    title: 'Планер "Чемпіонка"',
    desc: 'Для енергійних дівчаток, які люблять рух, гімнастику та яскраві кольори.',
    fullDesc:
      'Створений для активних дівчаток, які не сидять на місці. Яскравий та динамічний дизайн надихає на виконання ранкових рутин та спортивних вправ. Кожна зібрана зірочка — це крок до нових перемог.',
    img: 'https://cdn.magicpatterns.com/uploads/ecUzNdEEjzpwDo71iXEEBn/IMG_5252.jpg',
    price: '1000',
  },
  {
    id: 4,
    title: 'Планер "Принцеса"',
    desc: 'Казковий дизайн для маленьких мрійниць. З єдинорогами та замком.',
    fullDesc:
      "Чарівний планер, який перетворить нудні обов'язки на казкову гру. Ніжний дизайн з єдинорогами та замком допоможе маленькій принцесі з радістю виконувати свої щоденні завдання та вчитися бути самостійною.",
    img: 'https://cdn.magicpatterns.com/uploads/e7FsnN7qF4kJi2vc7FRRec/IMG_5253.jpg',
    price: '1000',
  },
]
